// // import React from 'react';
// // import '../Styles/ChangePassword.css'

// // const ChangePassword = () => {
// //   return (
// //     <div>
      
// //       <div className ="changepassword-form">
// //         <div className="changepassword-title">Change Password</div>
// //         <div className ="changepassword-note">Use the below to change the password</div>
// //         <div className ="changepassword-textfield">
// //         <label>OLD PASSWORD</label>
// //          <input type ="text" name="oldPassword"/>
        
// //         </div>
// //         <div className ="changepassword-textfield">
// //         <label>NEW PASSWORD</label>
// //          <input type ="text" name="newPassword"/>
        
// //         </div>
// //         <div className ="changepassword-textfield">
// //         <label>CONFIRM PASSWORD</label>
// //          <input type ="text" name="confirmPassword"/>
       
// //         </div>
// //         <button className="changepassword-submit">Submit</button>
// //       </div>
// //     </div>
// //   )
// // };

// // export default ChangePassword;
// //---------------------18-06-2025---------------
// import React, { useState } from 'react';
// import '../Styles/ChangePassword.css';

// const ChangePassword = () => {
//   const [form, setForm] = useState({
//     oldPassword: '',
//     newPassword: '',
//     confirmPassword: '',
//   });

//   const [message, setMessage] = useState('');
//   const [status, setStatus] = useState('');

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async () => {
//     const emailAddress = localStorage.getItem("agencyEmail"); // Adjust this based on your app's auth
//     if (!emailAddress) {
//       setStatus('error');
//       setMessage("User not logged in or email not found.");
//       return;
//     }

//     const { oldPassword, newPassword, confirmPassword } = form;

//     if (!oldPassword || !newPassword || !confirmPassword) {
//       setStatus('error');
//       setMessage("All fields are required.");
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setStatus('error');
//       setMessage("New password and confirm password do not match.");
//       return;
//     }

//     try {
//       const response = await fetch('https://b2bbackendapi.mmstourism.com/api/agency/forgotPassword', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ emailAddress, oldPassword, newPassword, confirmPassword }),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         setStatus('success');
//         setMessage("Password updated successfully.");
//         setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
//       } else {
//         setStatus('error');
//         setMessage(result.message || "Something went wrong.");
//       }
//     } catch (error) {
//       setStatus('error');
//       setMessage("Error updating password.");
//     }
//   };

//   return (
//     <div className="changepassword-form">
//       <div className="changepassword-title">Change Password</div>
//       <div className="changepassword-note">Use the form below to change your password</div>

//       <div className="changepassword-textfield">
//         <label>OLD PASSWORD</label>
//         <input
//           type="password"
//           name="oldPassword"
//           value={form.oldPassword}
//           onChange={handleChange}
//         />
//       </div>

//       <div className="changepassword-textfield">
//         <label>NEW PASSWORD</label>
//         <input
//           type="password"
//           name="newPassword"
//           value={form.newPassword}
//           onChange={handleChange}
//         />
//       </div>

//       <div className="changepassword-textfield">
//         <label>CONFIRM PASSWORD</label>
//         <input
//           type="password"
//           name="confirmPassword"
//           value={form.confirmPassword}
//           onChange={handleChange}
//         />
//       </div>

//       <button className="changepassword-submit" onClick={handleSubmit}>
//         Submit
//       </button>

//       {message && (
//         <div className={`changepassword-message ${status}`}>
//           {message}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ChangePassword;
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../Styles/ChangePassword.css';

const ChangePassword = () => {
  const location = useLocation();

  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const b2bAuthToken = localStorage.getItem("b2bAuthToken");

    if (!b2bAuthToken) {
      setStatus('error');
      setMessage("User not logged in.");
      return;
    }

    let phoneNumber = location.state?.phoneNumber || "";

    // Fallback to decode from token if phoneNumber not passed in location
    // if (!phoneNumber) {
    //   try {
    //     const parsedToken = JSON.parse(b2bAuthToken);
    //     const jwt = parsedToken.token?.split(' ')[1]; // Remove "Bearer"
    //     if (!jwt) throw new Error("Token not found");

    //     const payload = JSON.parse(atob(jwt.split('.')[1])); // Decode JWT
    //     phoneNumber = payload.phoneNumber;

    //     if (!phoneNumber) throw new Error("Phone number missing in token");
    //   } catch (err) {
    //     setStatus('error');
    //     setMessage("Invalid or malformed token.");
    //     return;
    //   }
    // }

    const { oldPassword, newPassword, confirmPassword } = form;

    if (!oldPassword || !newPassword || !confirmPassword) {
      setStatus('error');
      setMessage("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setStatus('error');
      setMessage("New password and confirm password do not match.");
      return;
    }

    try {
      const response = await fetch('https://b2bbackendapi.mmstourism.com/api/b2/agency/forgotPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phoneNumber,
          oldPassword,
          newPassword,
          confirmPassword
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage("Password updated successfully.");
        setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        setStatus('error');
        setMessage(result.message || "Something went wrong.");
      }
    } catch (error) {
      setStatus('error');
      setMessage("Error updating password.");
    }
  };

  return (
    <div className="changepassword-form">
      <div className="changepassword-title">Change Password</div>
      <div className="changepassword-note">Use the form below to change your password</div>

      <div className="changepassword-textfield">
        <label>OLD PASSWORD</label>
        <input
          type="password"
          name="oldPassword"
          value={form.oldPassword}
          onChange={handleChange}
        />
      </div>

      <div className="changepassword-textfield">
        <label>NEW PASSWORD</label>
        <input
          type="password"
          name="newPassword"
          value={form.newPassword}
          onChange={handleChange}
        />
      </div>

      <div className="changepassword-textfield">
        <label>CONFIRM PASSWORD</label>
        <input
          type="password"
          name="confirmPassword"
          value={form.confirmPassword}
          onChange={handleChange}
        />
      </div>

      <button className="changepassword-submit" onClick={handleSubmit}>
        Submit
      </button>

      {message && (
        <div className={`changepassword-message ${status}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default ChangePassword;
